// src/utils/logger.js

/**
 * Development-only diagnostics.
 *
 * Signalling, matching and route guards are genuinely hard to debug without a
 * running commentary, but that commentary does not belong in a customer's
 * console during a paid incident — it leaks internal ids and makes real errors
 * impossible to spot. `log` and `debug` compile away to a no-op in production
 * builds; `warn` and `error` always fire, because those we want to hear about.
 */

const isDev = process.env.NODE_ENV !== "production";

const noop = () => {};

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

export default logger;
